import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EventWebhookService, EventDelivery } from '../../core/services/core.event-webhook.service';

@Component({
    selector: 'event-delivery-detail',
    template: require('./event-delivery-detail.component.html'),
})
export class EventDeliveryDetailComponent implements OnChanges {
    @Input() deliveryId: number | null = null;

    delivery: EventDelivery | null = null;
    loading = false;
    error: string | null = null;
    showEnvelope = false;

    constructor(private service: EventWebhookService) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.deliveryId) {
            this.delivery = null;
            this.error = null;
            this.showEnvelope = false;
            if (this.deliveryId !== null) {
                this.load();
            }
        }
    }

    load() {
        this.loading = true;
        this.service.getDelivery(this.deliveryId!)
            .then(d => {
                this.delivery = d;
                this.loading = false;
            })
            .catch(err => {
                this.error = (err && err.error && err.error.message) || 'Failed to load delivery';
                this.loading = false;
            });
    }

    envelopeJson(): string {
        if (!this.delivery || !this.delivery.envelope) { return ''; }
        return JSON.stringify(this.delivery.envelope, null, 2);
    }

    statusClass(status: string): string {
        if (status === 'success')                     { return 'label-success'; }
        if (status === 'failed' || status === 'dead') { return 'label-danger'; }
        if (status === 'pending' || status === 'in_flight') { return 'label-warning'; }
        return 'label-default';
    }

    formatDuration(seconds: number): string {
        if (seconds < 60) {
            return `${seconds.toFixed(1)}s`;
        }
        const totalSeconds = Math.round(seconds);
        const minutes = Math.floor(totalSeconds / 60);
        const remainingSeconds = totalSeconds % 60;
        if (minutes < 60) {
            return `${minutes}m ${String(remainingSeconds).padStart(2, '0')}s`;
        }
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        return `${hours}h ${String(remainingMinutes).padStart(2, '0')}m`;
    }
}
